<template>
  <div>
    <div v-if="step === 0">
      <a-form-item class="form-item" label="User-ID">
        <a-input v-model="absenceCredentials.id"></a-input>
      </a-form-item>
      <a-button @click="nextStep" type="primary" html-type="button">
        Weiter <a-icon type="right" />
      </a-button>
    </div>

    <div v-if="step === 1">
      <a-form-item class="form-item" label="Api-Key">
        <a-input v-model="absenceCredentials.key"></a-input>
      </a-form-item>
      <a-button @click="nextStep" type="primary" html-type="button">
        Weiter <a-icon type="right" />
      </a-button>
    </div>

    <div v-if="step === 2">
      <a-form-item class="form-item" label="Excel Upload">
        <a-upload
          :showUploadList="false"
          :fileList="xlsxFiles"
          :remove="handleRemove"
          :beforeUpload="handleBeforeUpload"
        >
          <a-button>
            <a-icon type="loading" v-if="uploading" />
            <a-icon type="upload" v-if="!uploading" />
              {{uploading ? 'Converting...' : 'Select file' }} </a-button>
        </a-upload>
      </a-form-item>

      <div class="file-list" v-if="xlsxFiles.length > 0">
        <a-tag closable @close="handleRemove" v-for="file in xlsxFiles" v-bind:key="file.id">
          <a-icon type="file-excel" :id="file.uid" :data-size="file.size" /> {{ file.name }}
        </a-tag>
      </div>
    </div>
    <div id="working-time-table" v-if="step === 3">
      <div class="bulk-action-wrapper">
        <span class="transferStatus">
          <a-badge :showZero="true" :title="'Success: '" :count="importedToAbsence.length"
                   :numberStyle="{backgroundColor: '#34CE31', color: '#fff'}"
          />
          <a-badge :showZero="true" :title="'Errors: '" :count="importErrorToAbsence.length" />
          <a-badge :title="'Total: '" :count="workTimeItems.length"
                   :numberStyle="{backgroundColor: '#047FC8', color: '#fff'}" />
        </span>
        <a-button :showZero="true" :disabled="bulkImportRunning || uploading" type="primary"
                  :loading="importToAbsenceStarted"
                  @click="handleAbsenceBulkImport()">
          <a-icon type="loading" v-if="bulkImportRunning" />
          {{bulkImportRunning ? 'Importing...' : 'Bulk Import' }}
        </a-button>
      </div>
      <a-table :columns="columns" :dataSource="workTimeItems" rowKey="items" bordered>
            <span slot="start" slot-scope="start">
              {{ start | moment( 'timezone', 'Europe/Berlin', 'lll' )}}
            </span>
            <span slot="end" slot-scope="end">
              {{ end | moment( 'timezone', 'Europe/Berlin', 'lll' )}}
            </span>
            <span slot="type" slot-scope="type">
              <span v-if="type === 'break'" class="type type--break">
                🍔
              </span>
              <span v-if="type === 'work'" class="type type--work">
                💻
              </span>
            </span>
            <span class="actions" slot="actions" slot-scope="obj">
              <span v-if="isImportedToAbsence(obj)" class="imported"><a-icon type="like" /></span>
              <span v-if="isErrorByAbsenceImport(obj)" class="import-error">
                <a-icon type="close-circle" />
              </span>
              <a-button v-if="!isImportedToAbsence(obj) && !isErrorByAbsenceImport(obj)"
                        shape="circle" icon="cloud-upload" @click="handleAbsenceImport(obj)" />
            </span>
      </a-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import HawkClient from '@hapi/hawk';

export default {
  name: 'CollectorComponent',
  data() {
    const columns = [
      {
        title: 'Begin',
        key: 'start',
        dataIndex: 'start',
        scopedSlots: { customRender: 'start' },
      },
      {
        title: 'End',
        key: 'end',
        dataIndex: 'end',
        scopedSlots: { customRender: 'end' },
      },
      {
        title: 'Type',
        key: 'type',
        dataIndex: 'type',
        scopedSlots: { customRender: 'type' },
      },
      {
        title: '',
        scopedSlots: { customRender: 'actions' },
      },
    ];
    return {
      step: 0,
      valid: true,
      xlsxFiles: [],
      fileList: [],
      uploading: false,
      workTimeItems: [],
      importedToAbsence: [],
      importErrorToAbsence: [],
      importToAbsenceStarted: false,
      bulkImportRunning: false,
      columns,
      absenceCredentials: {
        id: '', // API-Key
        key: '', // User ID
        algorithm: 'sha256', // the algorythm used to build the request header
      },
      API_BASE_URL: 'https://app.absence.io/api/v2/',
      API_CONTENT_TYPE: 'application/json',
    };
  },
  watch: {
    userId(val) {
      this.setValidateStatus((val && val.length > 5));
    },
    apiKey(val) {
      this.setValidateStatus((val && val.length > 5));
    },
  },
  created() {
    this.closeNotifications();
  },
  methods: {
    nextStep() {
      this.step = this.step + 1;
      this.setValidateStatus(false);
    },
    setValidateStatus(status) {
      this.valid = status;
    },

    /**
     * Handle upload
     */
    handleBeforeUpload(f) {
      this.closeNotifications();
      if ((!f && !f.type) || !this.isSpreadsheetFile(f.type)) {
        this.showNotification('error', 'Wrong file', `The file is not from type openxmlformats-officedocument.spreadsheetml. You have uploaded a file from type ${f.type}`);
        this.valid = false;
        return false;
      }

      this.handleRemove();
      this.xlsxFiles.push(f);
      this.handleConverting();

      return false;
    },

    handleRemove() {
      this.xlsxFiles = [];
    },

    handleConverting() {
      this.uploading = true;
      // @todo manuall selection of months
      const formData = new FormData();
      formData.append('xlsx', this.xlsxFiles[0]);
      formData.append('months[]', 1);
      formData.append('months[]', 2);
      formData.append('months[]', 3);
      formData.append('months[]', 4);
      formData.append('months[]', 5);
      formData.append('months[]', 6);
      formData.append('months[]', 7);
      formData.append('months[]', 8);
      formData.append('months[]', 9);
      formData.append('months[]', 10);
      formData.append('months[]', 11);
      formData.append('months[]', 12);

      axios.post('https://api.cc-absence.c2x.li/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => {
        this.workTimeItems = res.data;
        this.step = 3;
      }).catch(() => {
        this.showNotification('error', 'Upload', 'Unknown api request error');
      }).finally(() => {
        this.uploading = false;
      });
    },

    isImportedToAbsence(obj) {
      return this.importedToAbsence.includes(obj);
    },

    isErrorByAbsenceImport(obj) {
      return this.importErrorToAbsence.includes(obj);
    },

    handleAbsenceBulkImport() {
      this.bulkImportRunning = true;
      const items = this.workTimeItems;
      console.log('ITEMS: ', items);
      items.forEach((item) => {
        Object.assign(item, { userId: this.absenceCredentials.id });
        this.handleAbsenceImport(item);
      });
      this.bulkImportRunning = false;
    },

    handleAbsenceImport(obj, bulk = false) {
      const absenceObj = Object.assign(obj, { userId: this.absenceCredentials.id });
      const absenceHeader = HawkClient.client.header(
        `${this.API_BASE_URL}timespans/create`,
        'POST',
        { credentials: this.absenceCredentials },
      );

      const requestHeader = {
        'Authorization': absenceHeader.header,
      };

      axios.post(`${this.API_BASE_URL}timespans/create`, absenceObj, {
        headers: requestHeader,
      }).then(() => {
        this.showNotification('success', 'Import to absence done', '', 1.5);
        this.importedToAbsence = [...this.importedToAbsence, obj];
      }).catch(() => {
        this.showNotification('error', 'Absence Error', '', 2.5);
        this.importErrorToAbsence = [...this.importErrorToAbsence, obj];
      });

      // @todo bulk operation
      if (bulk) {
        this.importToAbsenceStarted = true;
        this.importedToAbsence = this.workTimeItems;
        return false;
      }

      return true;
    },

    /**
     * Is file a spreadsheet file
     *
     * @param file
     * @returns {boolean}
     */
    isSpreadsheetFile(filetype) {
      return filetype.includes('openxmlformats-officedocument.spreadsheetml.sheet');
    },

    /**
     * Show an notification box
     * @param type | error, warning, info, success
     * @param title
     * @param message
     * @param duration
     */
    showNotification(type, title, message, duration = 0) {
      this.$notification[type]({
        message: title,
        description:
          message,
        duration,
      });
    },

    /**
     * Close open notifications
     */
    closeNotifications() {
      this.$notification.destroy();
    },
  },
};
</script>

<style scoped type="scss">
  #working-time-table .type {
    display: block;
    margin: 0 auto;
    text-align: center;
    font-size: 1.2rem;
  }
  #working-time-table .anticon.anticon-like {
    display: block;
    margin: 0 auto;
    color: green;
    font-size: 1.9rem;
  }
  #working-time-table .import-error .anticon {
    color: red;
    font-size: 1.9rem;
    display: block;
    margin: 0 auto;
  }
  #working-time-table .actions button {
    display: block;
    margin: 0 auto;
  }
  #working-time-table .bulk-action-wrapper {
    text-align: right;
    margin-bottom: 16px;
  }
  #working-time-table .transferStatus {
    margin-left: 24px;
  }
  #working-time-table .ant-badge-not-a-wrapper {
    margin: 0 3px;
  }
</style>
